import { FeatureModule } from '@/features/earn';
import { RootStackRoutes } from 'types';
import { DevToolsNavigator } from './Devtools';
import { DevToolsStackRoutes } from './types';

const DevToolsApp: FeatureModule = {
  name: RootStackRoutes.DevTools,
  version: '1.0.0',
  hooks: {},
  screens: {
    main: DevToolsNavigator,
    DevToolsNavigator
  },
  routes: {
    [DevToolsStackRoutes.Main]: {
      path: 'dev-tools/main'
    },
    [DevToolsStackRoutes.Button]: {
      path: 'dev-tools/button'
    },
    [DevToolsStackRoutes.Colours]: {
      path: 'dev-tools/colours'
    },
    [DevToolsStackRoutes.Icons]: {
      path: 'dev-tools/icons'
    },
    [DevToolsStackRoutes.Input]: {
      path: 'dev-tools/input'
    },
    [DevToolsStackRoutes.Typography]: {
      path: 'dev-tools/typography'
    },
    [DevToolsStackRoutes.Others]: {
      path: 'dev-tools/others'
    },
    [DevToolsStackRoutes.BottomSheet]: {
      path: 'dev-tools/bottom-sheet'
    },
    [DevToolsStackRoutes.Modal]: {
      path: 'dev-tools/modal'
    }
  },
  i18n: {
    en: {},
    'zh-HK': {},
    'zh-CN': {}
  }
};

export default DevToolsApp;
